module.exports = __webpack_public_path__ + "4ff019bd65b7ce089f6df4c88bd7780a.svg";